import { Routes } from '~/domains/common/constants/routes';

export const contestMarketplaceHref = (contestId: string) =>
  `/marketplace/contest/${contestId}?tab=buy_now`;

export const listingHref = (listingId: string) => `/marketplace/listing/${listingId}`;

export const holdingHref = (entryId: string) =>
  `/marketplace/holdings?tab=holdings&entry=${entryId}`;

export const offerHref = (offerId: string) => `/marketplace/holdings?tab=offers&offer=${offerId}`;

export const receivedOffersHref = () => '/marketplace/offers?offers=sell';

export const offerSettingsHref = (contestId: string) => Routes.marketplaceSettings({ contestId });
